import { useEffect, useLayoutEffect } from "react";

/**
 * A hook that uses `useLayoutEffect` on the client and `useEffect` on the server.
 * This is useful for components that are used on CSR and SSR, as SSR does not support `useLayoutEffect`.
 */
export const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;
